import React from 'react';
import { Box, Typography } from '@mui/material';

import { PLAYER_ICON_DEFAULT } from '../../../../../common/staticData';

const GamePlayerLogo = ({ player, onShow, isSelected }) => {
    const getImage = () => {
        return player.player_image && player.player_image.length > 0 ? player.player_image : PLAYER_ICON_DEFAULT;
    };

    const getDisplayName = () => {
        if (player.player_first_name === null && player.player_last_name !== null)
            return player.player_last_name.length > 6 ? player.player_last_name.slice(0, 6) + '.' : player.player_last_name;
        else if (player.player_first_name !== null && player.player_last_name === null)
            return player.player_first_name.length > 6 ? player.player_first_name.slice(0, 6) + '.' : player.player_first_name;
        else if (player.player_first_name === null && player.player_last_name === null) return 'N/A';

        const first = player.player_first_name.length > 0 ? player.player_first_name.slice(0, 1) : '';
        const lastName = player.player_last_name.length > 6 ? player.player_last_name.slice(0, 5) + '.' : player.player_last_name;

        return `${first}. ${lastName}`;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '6px 2px',
                borderRadius: '8px',
                backgroundColor: isSelected ? '#6366f1' : '#ffffff',
                border: `1.5px solid ${isSelected ? '#6366f1' : '#e5e7eb'}`,
                cursor: 'pointer',
                transition: 'all 0.12s ease',
                '&:hover': {
                    borderColor: '#6366f1',
                    backgroundColor: isSelected ? '#6366f1' : '#f5f3ff'
                },
                width: '100%',
                minHeight: '90px'
            }}
        >
            {/* Player Image */}
            <Box
                sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    background: `url(${getImage()}) center center / cover no-repeat`,
                    backgroundColor: '#e5e7eb',
                    border: `2px solid ${isSelected ? 'rgba(255,255,255,0.3)' : '#e5e7eb'}`,
                    position: 'relative',
                    marginBottom: '4px'
                }}
            >
                {/* Jersey Number Badge */}
                {player.player_jersey_number < 999 && (
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: -2,
                            left: -2,
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: isSelected ? '#ffffff' : '#6366f1',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '8px',
                                fontWeight: 700,
                                color: isSelected ? '#6366f1' : '#ffffff'
                            }}
                        >
                            {player.player_jersey_number}
                        </Typography>
                    </Box>
                )}
                {/* Position Badge */}
                {player.player_position_short_name && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -2,
                            right: -4,
                            padding: '1px 3px',
                            borderRadius: '3px',
                            backgroundColor: isSelected ? 'rgba(255,255,255,0.9)' : '#f59e0b'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '7px',
                                fontWeight: 700,
                                color: isSelected ? '#f59e0b' : '#ffffff'
                            }}
                        >
                            {player.player_position_short_name}
                        </Typography>
                    </Box>
                )}
            </Box>

            {/* Player Name */}
            <Typography
                sx={{
                    fontSize: '9px',
                    fontWeight: 600,
                    color: isSelected ? '#ffffff' : '#374151',
                    textAlign: 'center',
                    lineHeight: 1.2,
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {getDisplayName()}
            </Typography>

            {/* Stats Button */}
            <Typography
                onClick={(e) => {
                    e.stopPropagation();
                    onShow(player, true);
                }}
                sx={{
                    marginTop: '2px',
                    fontSize: '8px',
                    fontWeight: 600,
                    color: isSelected ? 'rgba(255,255,255,0.8)' : '#9ca3af',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    '&:hover': {
                        color: isSelected ? '#ffffff' : '#6366f1',
                        textDecoration: 'underline'
                    }
                }}
            >
                Stats
            </Typography>
        </Box>
    );
};

export default GamePlayerLogo;
